import { EntitiesWithNoDropdownItems, RydeUiUnit } from "@ryde/shared";

export type RefreshDropdownItemsFn = (
  entity: RydeUiUnit,
  forceFetch?: boolean,
) => Promise<unknown> | undefined;

export const shouldRefreshDropdownAfterBulkProcess = ({
  isCanceled,
  successIds,
  selectedIds,
}: {
  isCanceled: boolean;
  successIds?: number[];
  selectedIds: number[];
}): boolean =>
  Boolean(successIds?.length) || (!isCanceled && selectedIds.length > 0);

export const refreshDropdownItemsForEntity = ({
  entity,
  getDropdownItems,
}: {
  entity: RydeUiUnit;
  getDropdownItems?: RefreshDropdownItemsFn;
}): void => {
  if (!getDropdownItems || EntitiesWithNoDropdownItems.includes(entity)) {
    return;
  }

  void getDropdownItems(entity, true);
};
